var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    !_vm.consentGiven
      ? _c("div", { staticClass: "consent-container p-3 p-lg-4" }, [
          _c(
            "div",
            { staticClass: "consent p-3 p-lg-4" },
            [
              _c("h3", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "ui.components.consents.media_embed.title",
                    expression: "'ui.components.consents.media_embed.title'",
                  },
                ],
                staticClass: "mb-3 mt-3 mt-lg-5",
              }),
              _c("p", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: {
                      path: "ui.components.consents.media_embed.description",
                      args: { source: _vm.source },
                    },
                    expression:
                      "{ path: 'ui.components.consents.media_embed.description', args: { source } }",
                  },
                ],
                staticClass: "mb-2",
              }),
              _c("p", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "ui.components.consents.media_embed.consent",
                    expression: "'ui.components.consents.media_embed.consent'",
                  },
                ],
                staticClass: "font-weight-bold",
              }),
              _c("ci-button", {
                staticClass: "mb-3",
                attrs: {
                  label: _vm.$t(
                    "ui.components.consents.media_embed.button_text"
                  ),
                  variant: "filled-primary",
                  icon: "mdi-check",
                },
                on: { click: _vm.giveConsent },
              }),
              _c(
                "p",
                { staticClass: "mb-3 mb-lg-5 text-sm font-weight-bold" },
                [
                  _c("a", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value:
                          "ui.components.consents.media_embed.privacy_policy_link_text",
                        expression:
                          "'ui.components.consents.media_embed.privacy_policy_link_text'",
                      },
                    ],
                    attrs: {
                      href: "/datenschutz",
                      target: "_blank",
                      rel: "noopener",
                    },
                  }),
                ]
              ),
            ],
            1
          ),
        ])
      : _c(
          "div",
          { staticClass: "embed-responsive", class: _vm.embedClasses },
          [
            _vm.source === "BigMarker"
              ? _c("div", { staticClass: "bigmarker" }, [
                  _c("iframe", {
                    attrs: {
                      title: "bigmarker-player",
                      width: "100%",
                      allow: "autoplay; encrypted-media",
                      src: `https://events.capinside.com/recordings/${_vm.sourceMediaId}?height=full&width=full`,
                      frameborder: "0",
                      allowfullscreen: "",
                    },
                  }),
                ])
              : _vm._e(),
            _vm.source === "Infogram"
              ? _c("div", { staticClass: "infogram" }, [
                  _c("div", {
                    ref: "infogramEmbed",
                    staticClass: "infogram-embed",
                    attrs: {
                      "data-id": _vm.sourceMediaId,
                      "data-title": _vm.sourceMediaTitle,
                      "data-type": "interactive",
                    },
                  }),
                ])
              : _vm._e(),
            _vm.source === "SoundCloud"
              ? _c("div", { staticClass: "soundcloud" }, [
                  _c("iframe", {
                    attrs: {
                      title: "soundcloud-player",
                      width: "100%",
                      height: "155px",
                      src: `https://w.soundcloud.com/player/?url=https://api.soundcloud.com/tracks/${_vm.sourceMediaId}&color=%23ff5500&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false`,
                      frameborder: "0",
                      allowfullscreen: "",
                    },
                  }),
                ])
              : _vm._e(),
            _vm.source === "Vimeo"
              ? _c("div", { staticClass: "vimeo" }, [
                  _c("iframe", {
                    attrs: {
                      title: "vimeo-player",
                      width: "100%",
                      height: "100%",
                      allow: "autoplay; encrypted-media",
                      src: `https://player.vimeo.com/video/${_vm.sourceMediaId}`,
                      frameborder: "0",
                      allowfullscreen: "",
                    },
                  }),
                ])
              : _vm._e(),
            _vm.source === "Youtube"
              ? _c("div", { staticClass: "youtube" }, [
                  _c("iframe", {
                    attrs: {
                      title: "youtube-player",
                      width: "100%",
                      height: "100%",
                      allow: "autoplay; encrypted-media",
                      src: `https://www.youtube-nocookie.com/embed/${_vm.sourceMediaId}?rel=0&modestbranding=1`,
                      frameborder: "0",
                      allowfullscreen: "",
                    },
                  }),
                ])
              : _vm._e(),
          ]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }